import { getIcingValueTexts, getVisibilityValueTexts, getWeatherInfoTexts } from "./weather-limits";

const MSToKN = 1.943844;

export function formatSpotWeatherElement(name: string, spotWeatherMap: Map<string, number[]>|null) {
    if (!spotWeatherMap || !spotWeatherMap.has(name)) {
        return "";
    }

    const values = spotWeatherMap.get(name);

    if (name === "Visibility") { return `${getVisibilityValueTexts()[values![0]]}`;}
    if (name === "Icing") { return `${getIcingValueTexts()[values![0]]}`;}
    if (name === "WeatherCode") { return `${getWeatherInfoTexts()[values![0]]}`;}

    if (name === "Wind10M"  ||
        name === "Wind50M"
        ) {

        const compassCourse = compassRose(values![0]);
        return `${compassCourse} ${(values![1]*MSToKN).toFixed(1)} kn`;
    }

    if (name === "Currents") {
        // Compass rose is showing FROM which direction element is coming.
        // For current the TOWARDS direction is needed.
        const convertedDirection = values![0] > 180 ? values![0]-180 : values![0] + 180;
        const compassCourse = compassRose(convertedDirection);
        return `${compassCourse} ${(values![1]*MSToKN).toFixed(1)} kn`;
    }

    if (name === "RiskWindSpeed" ||
        name === "WindGusts10M"  ||
        name === "WindGusts50M"
    ) return `${(values![0]*MSToKN).toFixed(0)} kn`;

    if (name === "AirTemperature" ||
        name === "SeaWaterTemperature" ||
        name === "DewPoint"
    ) return `${values![0]}°C ${(values![0]*1.8 + 32).toFixed(0)}F`;

    if (name === "Wave") {
        const wavePeriod = spotWeatherMap.has("WavePeriod") ? spotWeatherMap.get("WavePeriod")![0] : 0;
        const compassCourse = compassRose(values![0]);
        return `${compassCourse} ${wavePeriod}s ${values![1]} m`;
    }

    if (name === "Swell") {
        const swellPeriod = spotWeatherMap.has("SwellPeriod") ? spotWeatherMap.get("SwellPeriod")![0] : 0;
        const compassCourse = compassRose(values![0]);
        return `${compassCourse} ${swellPeriod}s ${values![1]} m`;
    }
    
    if (name === "Pressure") return `${values![0]} hpa`;
    if (name === "RiskWaveHeight") return `${values![0]} m`;
    if (name === "Precipitation") return `${values![0]}%`;
    if (name === "HPa500") return `${values![0]} m`;
    if (name === "IceConcentration") return `${values![0]}%`;
    if (name === "RelativeHumidity") return `${values![0]}%`;
    if (name === "FreezingLevel") return `${(values![0]*3.2808).toFixed(0)} ft`;
    if (name === "SeaWaterSalinity") return `${values![0]} psu`;

    return "Invalid element";
}

export function compassRose(deg: number) {
    if (deg >= 11.25 && deg < 33.75) return "NNE";
    if (deg >= 33.75 && deg < 56.25) return "NE";
    if (deg >= 56.25 && deg < 78.75) return "ENE";
    if (deg >= 78.75 && deg < 101.25) return "E";
    if (deg >= 101.25 && deg < 123.75) return "ESE";
    if (deg >= 123.75 && deg < 146.25) return "SE";
    if (deg >= 146.25 && deg < 168.75) return "SSE";
    if (deg >= 168.75 && deg < 191.25) return "S";
    if (deg >= 191.25 && deg < 213.75) return "SSW";
    if (deg >= 213.75 && deg < 236.25) return "SW";
    if (deg >= 236.25 && deg < 258.75) return "WSW";
    if (deg >= 258.75 && deg < 281.25) return "W";
    if (deg >= 281.25 && deg < 303.75) return "WNW";
    if (deg >= 303.75 && deg < 326.25) return "NW";
    if (deg >= 326.25 && deg < 348.75) return "NNW";
    if ((deg >= 348.75 && deg <= 360) || (deg >= 0 && deg < 11.25)) return "N";
}